import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingEnglishImageTranslatorConfig } from '@/data/landingConfig/landingEnglishImageTranslatorConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_EnglishImageTranslator } from './schemaObject';

interface Props {}
const EnglishImageTranslator: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_EnglishImageTranslator} />
			<LandingTemplate
				data={landingEnglishImageTranslatorConfig}
				funnelLinkService={GenerateLandingLinkService.funnelAiImageTranslator()}
			/>
		</>
	);
};

export default EnglishImageTranslator;
